<template>
	<div>
		<v-layout wrap px-5 pt-4 pb-5>
			<v-flex xs12 md6 pr-3 pb-5>
				<v-layout wrap>
					<v-flex xs12>
						<label class="title-form">DATOS GENERALES</label>
					</v-flex>
					<v-flex xs12>
						<v-divider></v-divider>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseInput
							required
							label="Código"
							:height="38"
							:is-loading="isLoading"
							v-model="model.code"
						>
							<span slot="error" class="caption error--text" v-if="$v.model.code.$invalid">
								El código es requerido
							</span>
						</BaseInput>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseInput
							required
							label="Orden"
							:height="38"
							:is-loading="isLoading"
							v-model="model.order"
						>
						</BaseInput>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseInput
							required
							label="Descripción"
							:height="38"
							:is-loading="isLoading"
							v-model="model.description"
						/>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseInput
							required
							label="Campo"
							:height="38"
							:is-loading="isLoading"
							v-model="model.startTag"
						/>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseInput
							required
							label="Final Campo"
							:height="38"
							:is-loading="isLoading"
							v-model="model.endTag"
						/>
					</v-flex>
					<v-flex xs12 pt-3>
						<BaseSelect
							label="Módulo"
							item-text="name"
							item-value="id"
							:is-loading="isLoading"
							:height="38"
							:items="modules"
							:readonly="!!id"
							:disabled="!!id"
							v-model="model.moduleId"
							@input="loadDataDictionary"
						>
							<span slot="error" class="caption error--text" v-if="$v.model.moduleId.$invalid">
								El módulo es requerido
							</span>
						</BaseSelect>
					</v-flex>
					<v-flex xs12 md3 mb-3 pt-3>
						<v-layout row wrap align-center justify-center>
							<v-flex xs12 md6>
								<label class="caption">Etiqueta padre</label>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="model.fatherTag"
									:label="automaticAccountingName(model.fatherTag)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									hide-details
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12>
						<label class="title-form">DATOS ADICIONALES</label>
					</v-flex>
					<v-flex xs12>
						<v-divider></v-divider>
					</v-flex>
					<v-flex xs12 py-2>
						<v-layout wrap align-center>
							<v-flex xs6>
								<app-intelissense
									label="Condición"
									tag-name="BaseInput"
									:height="38"
									:is-loading="isLoading"
									:items="dictionaryData"
									:value="model.terms"
									:disabled="!model.moduleId"
									v-model="model.terms"
									id="terms"
									@input="validateData($event, 'terms')"
									@click-item="clickItem('terms', $event)"
								></app-intelissense>
								<div class="err-msg">
									<span class="caption"
										:class="{ 'error--text' : dataErrorTerms, 'success--text' : dataVerifiedTerms }"
										>
										{{ dataMessageTerms }}
									</span>
								</div>
							</v-flex>
							<template v-if="dataVerifiedTerms || dataErrorTerms">
								<v-flex xs4 text-xs-center>
									<span class="caption">{{ termsExample }}</span>
								</v-flex>
								<v-flex xs2>
									<v-btn
										:color="dataVerifiedTerms ? 'success' : 'error'"
										dark
										icon
										small
									>
										<v-icon color="white">
											<template v-if="dataVerifiedTerms">
												check
											</template>
											<template v-else>
												close
											</template>
										</v-icon>
									</v-btn>
								</v-flex>
							</template>
						</v-layout>
					</v-flex>
					<v-flex xs12 pt-3 class="pos-relative">
						<span class="caption white--text px-2 caption-input"
							:class="formulaError ? 'error' : 'success'">EJEMPLO</span>
						<BaseInput
							label="Fórmula"
							hide-details
							readonly
							disabled
							:is-loading="isLoading"
							:height="45"
							v-model="formulaExample"
						/>
					</v-flex>
					<v-flex xs12>
						<app-intelissense
							background-color="white"
							solo
							flat
							class="body-1 text-area"
							no-resize
							hide-details
							:items="dictionaryData"
							:value="model.formula"
							:disabled="!model.moduleId"
							:readonly="!model.moduleId"
							v-model="model.formula"
							id="formula"
							@input="setFormulaExample"
							@click-item="clickItem('formula', $event)"
						></app-intelissense>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md6 pl-3 pb-5>
				<modulesCard
					:columns="columnsMod"
					:current-page="currentPageMod"
					:last-page="lastPageMod"
					:module-id="model.moduleId"
					:module-name="module ? module.name : null"
				/>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				success-color="cyan"
				success-text="Guardar"
				:is-loading="disabled"
				@cancel-button-clicked="cancel"
				@accept-button-clicked="save"
			></modal-sidebar-button>
		</section>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<slide-searcher
				v-if="isActionCode('searcher')"
				:columns="columns"
				:current-page="currentPage"
				:last-page="lastPage"
				:rows="rows"
				@add-record="addRecord"
				@on-close="closeModal"
				@on-page="changePage"
				@on-search="onSearchRecords"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import { minValue, required } from 'vuelidate/lib/validators';
	import actionSidebar from '@/components/shared/action-sidebar';
	import appIntelissense from '@/components/shared/app-intelissense';
	import helper from '@/shared/helper';
	import inputSearcher from '@/components/shared/searcher/input-searcher';
	import modulesCard from '@/components/definitions-ats/modules-ats-tab';
	import slideSearcher from '@/components/shared/searcher/slide-searcher';
	import { mapGetters } from 'vuex';

	const { debounce } = helper;

	async function mounted() {
		this.isLoading = true;
		await this.loadResources();
		this.isLoading = false;
	}
	function addRecord({ account, code, name }) {
		const codeAccount = `'${code}'`;
		this.search = account;
		this.model.accountingAccount = account;
		this.accountingCode = codeAccount;
		this.accountingAccountName = name;
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
	}

	function automaticAccountingName({ automaticAccounting }) {
		return automaticAccounting ? 'Si' : 'No';
	}

	function cancel() {
		this.goTo('accouting-ats-rules');
	}

	function changePage(page) {
		this.loadRecords(page);
	}

	function clickItem(propName, { item, selectionStart }) {
		this.model[propName] = this.replaceString(this.model[propName], selectionStart, item.code);
		this.$nextTick(() => {
			const f = document.querySelector(`#${propName}`);
			f.focus();
			f.selectionStart = selectionStart + item.code.length;
			f.selectionEnd = selectionStart + item.code.length;
			this.validateData(this.model[propName], propName);
		});
	}

	function closeModal() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		delete this.recordsParams.search;
	}

	function disabled() {
		return this.loading || this.$v.$invalid || this.validateScript;
	}

	function isActionCode(code) {
		return this.action.code === code;
	}

	async function loadDataDictionary(id) {
		const params = { moduleId: this.model.moduleId || id };
		this.module = this.modules.find(mod => mod.id === params.moduleId);
		({ data: this.dictionaryData } = await this.$http.get('data-dictionary-transactional', { params }));
	}

	async function loadResources() {
		const subsidiaryId = this.$route.query.subsidiaryId || this.currentSubsidiary.id;
		const request = [
			this.$http.get('type-register', { params: { subsidiaryId } }),
			this.$http.get(`automatic-configuration/${subsidiaryId}/accounting`),
		];
		[{ data: this.modules }, { data: this.accountingAccounts }] = await Promise.all(request);
		if (this.id) {
			this.loadRule();
		} else {
			this.model.moduleId = this.modules.length > 0 ? this.modules[0].id : null;
			this.loadDataDictionary();
		}
	}

	async function loadRecords(page = 1) {
		this.currentPage = page;
		this.recordsParams.page = page;
		const subsidiaryId = this.$route.query.subsidiaryId || this.currentSubsidiary.id;
		try {
			const { data: records, headers } = await this.$http.get(
				`accounting-plan/${subsidiaryId}/subsidiary`,
				{ params: this.recordsParams });
			this.lastPage = Number(headers['x-last-page']);
			this.rows = [...records];
			if (this.id) {
				const accAcc = this.rows.find(acc => acc.account === this.search ||
					acc.code === this.search) || {};
				this.accountingAccountName = accAcc.name;
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadRule() {
		try {
			({ data: this.model } = await this.$http.get(`rules-transactional-detail/${this.id}`));
			if (this.model.entity === 3) {
				this.flagAccountingProduct = true;
			}
			if (this.model.entity === 5) {
				this.flagAccountingBank = true;
			}
			if (this.model.entity === 6) {
				this.flagCountAccounting = true;
				let newAccoutingAccount = this.model.accountingAccount.substring(1);
				newAccoutingAccount
				= newAccoutingAccount.slice(0, -1);
				this.search = newAccoutingAccount;
				const searchVal = this.search.replace(/\./g, '');
				this.recordsParams.search = searchVal.trim();
				this.model.accountingAccount = this.search;
			} else {
				const newAccoutingAccount = this.model.accountingAccount;
				this.search = newAccoutingAccount;
				this.model.accountingAccount = this.search;
			}
			this.loadDataDictionary();
			this.loadRecords();
			this.model.accountingAccount = this.search;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function onInput(value) {
		this.search = value;
		if (value) {
			const invalidValue = value.indexOf('.') > -1;
			const newValue = invalidValue ? value.replace(/\./g, '') : value;
			this.recordsParams.search = newValue;
		} else {
			delete this.recordsParams.search;
		}
	}

	function onSearchRecords(searchTable) {
		if (!searchTable) {
			if (this.search) {
				const invalidValue = this.search.indexOf('.') > -1;
				const newValue = invalidValue ? this.search.replace(/\./g, '') : this.search;
				this.recordsParams.search = newValue.trim();
			} else {
				delete this.recordsParams.search;
			}
		} else {
			this.recordsParams.search = searchTable.trim();
		}
		this.loadRecords();
	}

	function openSearcher() {
		this.action.title = 'Buscar Cuenta Contable';
		this.action.code = 'searcher';
		this.action.width = 550;
		this.action.value = true;
		if (this.search) {
			this.search = '';
			this.onInput(this.search);
		}
		this.loadRecords();
	}

	async function save() {
		this.loading = true;
		const method = this.id ? 'patch' : 'post';
		const url = this.id ? `rules-transactional/${this.id}` : 'rules-transactional';
		const action = this.id ? 'editada' : 'creada';
		const body = {
			code: this.model.code,
			description: this.model.description,
			formula: this.model.formula,
			startTag: this.model.startTag,
			endTag: this.model.endTag,
			order: this.model.order,
			terms: this.model.terms || null,
			moduleId: this.model.moduleId,
			fatherTag: this.model.fatherTag,
		};
		if (!this.id) {
			body.moduleId = this.model.moduleId;
		}
		try {
			await this.$http[method](url, body);
			this.showNotification(`La regla ha sido ${action} correctamente.`);
			this.cancel();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'RULE_CODE_REPEATED') {
					this.showGenericError('No se pueden crear reglas con un código repetido.');
				} else {
					this.showGenericError();
				}
			}
		} finally {
			this.loading = false;
		}
	}

	async function setFormulaExample(value) {
		this.validateScript = true;
		const body = { script: value };
		if (value) {
			try {
				const { data: response } = await this.$http.post(
					`rules-transactional/${this.model.moduleId}/validation`, body);
				this.formulaError = !response.result;
				this.formulaExample = response.result;
				this.validateScript = false;
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				} else if (err.status === 400) {
					this.formulaError = true;
					this.formulaExample = err.data.description;
					if (err.data.message === 'RULE_SYNTAX_ERROR') {
						this.showGenericError('Error de sintaxis. Algún campo del diccionario de datos no es correcto.');
					} else if (err.data.message === 'DICTIONARY_EMPTY') {
						this.showGenericError('El diccionario de datos del módulo se encuentra vacío.');
					}
				}
			}
		} else {
			this.validateScript = false;
			this.formulaError = false;
			this.formulaExample = '';
		}
	}

	function showAccountingAccount(val) {
		this.model.accountingAccount = val.account;
		this.search = val.account;
	}

	async function validateData(dataValid, model) {
		this.validateScript = true;
		const type = { key: '' };
		if (model !== 'reference') {
			type.key = model === 'concept' ? 'Concept' : 'Terms';
		} else {
			delete type.key;
		}
		const body = { script: dataValid };
		const newKey = type.key ? `dataVerified${type.key}` : 'dataVerified';
		const newKeyError = type.key ? `dataError${type.key}` : 'dataError';
		const newKeyEx = type.key ? `${model}Example` : 'referenceExample';
		const newKeyMessage = type.key ? `dataMessage${type.key}` : 'dataMessage';
		if (dataValid) {
			try {
				const { data: response } = await this.$http.post(
					`rules-transactional/${this.model.moduleId}/validation`, body);
				this[newKey] = true;
				this[newKeyError] = false;
				this[newKeyEx] = `Ejemplo: ${response ? response.result : ''}`;
				this[newKeyMessage] = 'Data Verificada';
				this.validateScript = false;
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				} else if (err.status === 400) {
					if (err.data.message === 'RULE_SYNTAX_ERROR') {
						this.showGenericError('Error de sintaxis. Algún campo del diccionario de datos no es correcto.');
					} else if (err.data.message === 'DICTIONARY_EMPTY') {
						this.showGenericError('El diccionario de datos del módulo se encuentra vacío.');
					}
				}
				this[newKey] = false;
				this[newKeyError] = true;
				this[newKeyEx] = '';
				this[newKeyMessage] = 'Dato Inválido';
			}
		} else {
			this[newKey] = false;
			this[newKeyError] = false;
			this[newKeyEx] = '';
			this[newKeyMessage] = '';
			this.validateScript = false;
		}
	}

	function validations() {
		return {
			model: {
				code: { required },
				moduleId: { minValue: minValue(1), required },
			},
		};
	}

	function data() {
		return {
			accountingAccounts: [],
			accountingAccount: null,
			accountingAccountName: null,
			accountingCode: null,
			action: {
				code: '',
				title: '',
				value: false,
			},
			columns: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Cuenta', value: 'account', checked: true, visible: true },
				{ id: 3, name: 'Nombre', value: 'name', checked: true, visible: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			columnsMod: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
				{ id: 3, name: 'Descripción', value: 'description', checked: true, visible: true },
				{ id: 4, name: 'Ejemplo', value: 'example', checked: true, visible: true },
			],
			codeBank: [
				{ id: 1, name: 'Cuenta Bancaria', value: 'codeBank' },
				{ id: 2, name: 'Cheque', value: 'codeCheck' },
			],
			codeProduct: [
				{ id: 1, name: 'Inventario', value: 'inventory' },
				{ id: 2, name: 'Ventas', value: 'sales' },
				{ id: 3, name: 'Descuento', value: 'discount' },
				{ id: 4, name: 'Costos', value: 'costs' },
				{ id: 5, name: 'Devolución', value: 'repayment' },
				{ id: 6, name: 'P.Proceso', value: 'process' },
			],
			codeAccounting: [
				{ id: 1, name: 'Cliente', value: 'customer' },
				{ id: 2, name: 'Proveedor', value: 'supplier' },
				{ id: 3, name: 'Producto', value: 'description' },
				{ id: 4, name: 'Caja', value: 'Cash' },
				{ id: 5, name: 'Banco', value: 'Bank' },
				{ id: 6, name: 'Cuenta Contable', value: 'accountingCount' },
				{ id: 7, name: 'Retención', value: 'withholdingTaxActive.codeAccounting' },
			],
			flagCountAccounting: false,
			flagAccountingBank: false,
			flagAccountingProduct: false,
			conceptExample: null,
			dataRule: '',
			currentPage: 1,
			currentPageMod: 1,
			dataError: false,
			dataErrorConcept: false,
			dataErrorTerms: false,
			dataMessage: '',
			dataMessageConcept: '',
			dataMessageTerms: '',
			dataVerified: false,
			dataVerifiedConcept: false,
			dataVerifiedTerms: false,
			dictionaryData: [],
			formulaExample: '',
			formulaError: '',
			isLoading: false,
			customerName: '',
			lastPage: 0,
			lastPageMod: 0,
			loading: false,
			model: {
				code: null,
				description: null,
				formula: null,
				startTag: null,
				endTag: null,
				reference: null,
				order: null,
				terms: null,
				moduleId: null,
				fatherTag: false,
			},
			module: {},
			modules: [],
			recordsParams: {
				limit: 20,
				page: 1,
				status: 1,
			},
			referenceExample: null,
			termsExample: null,
			rows: [],
			search: null,
			show: false,
		};
	}

	export default {
		name: 'rules-ats-form',
		components: {
			actionSidebar,
			appIntelissense,
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			inputSearcher,
			modulesCard,
			slideSearcher,
		},
		computed: {
			disabled,
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
		},
		data,
		methods: {
			addRecord,
			cancel,
			automaticAccountingName,
			changePage,
			clickItem,
			closeModal,
			isActionCode,
			loadDataDictionary,
			loadRecords,
			loadResources,
			loadRule,
			onInput,
			onSearchRecords,
			openSearcher,
			save,
			setFormulaExample: debounce(setFormulaExample),
			showAccountingAccount,
			validateData: debounce(validateData),
		},
		mounted,
		props: {
			id: [Number, String],
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.pos-relative {
		position: relative;
	}

	.caption-input {
		align-items: center;
		border-bottom-left-radius: 15px;
		border-top-right-radius: 15px;
		height: 28px;
		display: flex;
		justify-content: center;
		position: absolute;
		right: 0;
		width: 99px;
		z-index: 1;
	}

	.err-msg {
		transform: translateY(-20px);
	}
</style>



// WEBPACK FOOTER //
// src/components/rules-ats/rules-ats-form.vue